import axios from 'axios'
import axiosClient from '../utils/API'
import React, {useState, useContext, useEffect} from 'react'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  withRouter,
  Link,
} from 'react-router-dom'
import swal from 'sweetalert'
import logo from '../img/logo.svg'
import {ContextApp} from '../context/ContextApp'
import Spinner from './Spinner'

export default () => {
  const contextApp = useContext(ContextApp)
  const {
    getUserInformation,
    setCategoryShowClose,
    getUserAddress,
    user,
  } = contextApp

  // localStorage.removeItem('userInfo');
  const [inputValue, setInputValue] = React.useState('')

  const [fName, setfName] = useState('')
  const [lName, setlName] = useState('')

  const [Ramil, setRmail] = useState('')
  const [Rnombre, setrnombre] = useState('')
  const [dui, setdui] = useState('')
  const [Rpassword, setRpassword] = useState('')
  const [RTelefono, setRTelefono] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    setCategoryShowClose()
  }, [])

  const [islogged, setlogged] = useState(false)

  const submitValue = () => {
    setShowSpinner(true)

    const data = {
      email: fName,
      password: lName,
    }

    axios
      .post(
        'http://34.106.141.22/aeromall-adminfix/public/api/login',
        //'http://backendleweb/public/api/login',
        data)
      
      // 'https://aeromall.com.sv/aeromall-admin/public/api/login'
      //axios.post('http://ditto.centralus.cloudapp.azure.com/aeromall/public/api/login', data)
      //axios.post('http://34.106.51.11/aeromall-admin/public/api/login', data)
      //axios.post('http://34.106.141.22/aeromall-admin/public/api/login', data)
      //axios.post('http://192.168.1.170:8000/api/login', data)
      .then(res => {
        console.log(res)

        getUserInformation(res.data)
        setShowSpinner(false)

        const {id, name, email} = res.data.user

        const DataUser = {
          Id: id,
          Nombre: name,
          Email: email,
        }

        if (Object.keys(res.data).length > 0) {
          console.log('Datos', res.data.user.name)
          const userstrg = JSON.stringify(DataUser)

          localStorage.setItem('userInfo', res.data.user.name)

          setlogged(true)
        }
      })
      .catch(error => {
        console.error(error)
        setShowSpinner(false)

        swal(`${error.response.data.error}`, '', 'error')
      })
  }

  const CrateUser = () => {
    const CreateUserData = {
      email: Ramil,
      name: Rnombre,
      password: Rpassword,
      phone: RTelefono,
      dui,
    }

    axios
    .post(
      'http://34.106.141.22/aeromall-adminfix/public/api/signup',
      //'http://34.106.141.22/aeromall-adminfix/public/api/signup',
      //'http://backendleweb.com/public/api/signup',
      CreateUserData,
      )
      // 'https://aeromall.com.sv/aeromall-admin/public/api/signup',
      //axios.post('http://ditto.centralus.cloudapp.azure.com/aeromall/public/api/signup', CreateUserData)
      //axios.post('http://34.106.51.11/aeromall-admin/public/api/signup', CreateUserData)
      //axios.post('http://34.106.141.22/aeromall-admin/public/api/signup', CreateUserData)
      //axios.post('http://192.168.1.170:8000/api/signup', CreateUserData)
      .then(res => {
        console.log(res)
        swal(`${res.data.message}`, '', 'success')
      })
      .catch(error => {
        console.error(error.response)
        swal(`Ops! ${error.response.data.error}`, '', 'error')
      })
  }

  return islogged ? (
    <Redirect to="/" />
  ) : (
    <body className="page home page-template-default">
      <div id="page" className="hfeed site">
        <a className="skip-link screen-reader-text" href="#site-navigation">
          Skip to navigation
        </a>
        <a className="skip-link screen-reader-text" href="#content">
          Skip to content
        </a>

        <div id="content" className="site-content" tabindex="-1">
          <div className="container">
            <nav className="woocommerce-breadcrumb">
              <a href="#"></a>
              <span className="delimiter"></span>
            </nav>

            <div id="primary" className="content-area">
              <main id="main" className="site-main">
                <article id="post-8" className="hentry">
                  <div className="entry-content">
                    <div className="woocommerce">
                      <div className="customer-login-form">
                        <div className="col2-set" id="customer_login">
                          <div className="col-1" style={{maxWidth: '50%'}}>
                            <h2>Ingresa</h2>

                            <form method="post" className="login">
                              <p className="before-login-text">
                                Bienvenido! Inicia session en tu cuenta
                              </p>

                              <p className="form-row form-row-wide">
                                <label for="username">
                                  Correo<span className="required">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="input-text"
                                  name="username"
                                  id="username"
                                  value={fName}
                                  onChange={e => setfName(e.target.value)}
                                />
                              </p>

                              <p className="form-row form-row-wide">
                                <label for="password">
                                  Password<span className="required">*</span>
                                </label>
                                <input
                                  className="input-text"
                                  type="password"
                                  name="password"
                                  id="password"
                                  value={lName}
                                  onChange={e => setlName(e.target.value)}
                                />
                              </p>
                              {showSpinner ? <Spinner /> : null}

                              <p className="form-row">
                                <input
                                  className="hero-action-btn"
                                  type="button"
                                  value="Iniciar"
                                  name="login"
                                  onClick={submitValue}
                                />
                                <label for="rememberme" className="inline">
                                  <input
                                    name="rememberme"
                                    type="checkbox"
                                    id="rememberme"
                                    value="forever"
                                  />{' '}
                                  Recuerdame
                                </label>
                              </p>

                              <p className="form-row lost_password">
                                <Link to={'/reset_password'} style={{color: 'black'}}>
                                  Olvidaste tu contraseña?
                                </Link>
                              </p>
                            </form>
                          </div>
                          <span className="or-text">or</span>

                          <div className="col-2" style={{maxWidth: '50%'}}>
                            <h2>Registrate</h2>

                            <form method="post" className="register">
                              <p className="before-register-text">
                                Crea tu cuenta
                              </p>

                              <p className="form-row form-row-wide">
                                <label for="reg_email">
                                  Correo<span className="required">*</span>
                                </label>
                                <input
                                  type="email"
                                  className="input-text"
                                  required="true"
                                  name="email"
                                  placeholder="tucorreo@correo.com"
                                  onChange={e => setRmail(e.target.value)}
                                  id="reg_email"
                                  value={Ramil}
                                />
                              </p>

                              <p className="form-row form-row-wide">
                                <label for="reg_email">
                                  Nombre<span className="required">*</span>
                                </label>
                                <input
                                  type="text"
                                  placeholder="Nombre completo"
                                  required="true"
                                  className="input-text"
                                  name="unsmr"
                                  onChange={e => setrnombre(e.target.value)}
                                  id="reg_Nombre"
                                  value={Rnombre}
                                />
                              </p>
                              <p className="form-row form-row-wide">
                                <label for="reg_email">
                                  DUI<span className="required">*</span>
                                </label>
                                <input
                                  type="text"
                                  placeholder="Ingresa tu DUI"
                                  required
                                  className="input-text"
                                  name="dui"
                                  onChange={e => setdui(e.target.value)}
                                  id="reg_Nombre"
                                  value={dui}
                                />
                              </p>
                              <p className="form-row form-row-wide">
                                <label for="reg_email">
                                  Contraseña<span className="required">*</span>
                                </label>
                                <input
                                  type="password"
                                  placeholder="Ingresa tu contraseña"
                                  required
                                  className="input-text"
                                  onChange={e => setRpassword(e.target.value)}
                                  name="pass"
                                  id="reg_pass"
                                  value={Rpassword}
                                />
                              </p>
                              <p className="form-row form-row-wide">
                                <label for="reg_email">
                                  Telefono<span className="required">*</span>
                                </label>
                                <input
                                  type="text"
                                  required
                                  className="input-text"
                                  name="phone"
                                  onChange={e => setRTelefono(e.target.value)}
                                  id="reg_phone"
                                  value={RTelefono}
                                />
                              </p>
                              <p>
                                {/*<input type='checkbox' name='terminos_condiciones' id='terminos_condiciones' />&nbsp;&nbsp;&nbsp;
                                                                <a href='https://www.aeromall.com.sv/aeromall-admin/public/storage/settings/September2020/p3lrwA2YXcvh0yPJM56q.pdf'>Terminos y condiciones de servicio</a>*/}
                                <div>
                                  <input
                                    type="checkbox"
                                    name="terminos_condiciones"
                                    id="terminos_condiciones"
                                  />
                                  &nbsp;
                                  <Link
                                    to={`/termsandconditions`}
                                    className="js-animation-link link-muted"
                                  >
                                    Términos y condiciones de servicio
                                  </Link>
                                </div>
                              </p>

                              <p className="form-row">
                                <input
                                  type="button"
                                  className="hero-action-btn"
                                  name="register"
                                  value="Registrarse"
                                  onClick={CrateUser}
                                />
                              </p>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </main>
            </div>
          </div>
        </div>

        <footer id="colophon" className="site-footer">
          <div className="footer-newsletter">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-7">
                  <h5 className="newsletter-title"></h5>
                  <span className="newsletter-marketing-text">
                    {' '}
                    <strong></strong>
                  </span>
                </div>
                <div className="col-xs-12 col-sm-5">
                  <form>
                    <div className="input-group"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom-widgets">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-7 col-md-push-5">
                  <div className="columns">
                    <aside
                      id="nav_menu-2"
                      className="widget clearfix widget_nav_menu"
                    >
                      <div className="body"></div>
                    </aside>
                  </div>
                  <div className="columns">
                    <aside
                      id="nav_menu-3"
                      className="widget clearfix widget_nav_menu"
                    >
                      <div className="body"></div>
                    </aside>
                  </div>

                  <div className="columns">
                    <aside
                      id="nav_menu-4"
                      className="widget clearfix widget_nav_menu"
                    >
                      <div className="body"></div>
                    </aside>
                  </div>
                </div>

                <div className="footer-contact col-xs-12 col-sm-12 col-md-5 col-md-pull-7">
                  <div class="footer-logo">
                    <a href="#" class="header-logo-link">
                      <img src={logo} />
                    </a>
                  </div>

                  <div className="footer-call-us">
                    <div className="media">
                      <span className="media-left call-us-icon media-middle">
                        <i className="ec ec-support"></i>
                      </span>
                      <div className="media-body">
                        <span className="call-us-text">
                          {' '}
                          ¿Tienes preguntas?, ¡Llámanos!
                        </span>
                        <span className="call-us-number">+(503) 2207-5190</span>
                      </div>
                    </div>
                  </div>

                  <div className="footer-address">
                    <strong className="footer-address-title">Para ayuda</strong>
                    <address>INFO@AEROMALL.COM.SV</address>
                  </div>

                  <div className="footer-social-icons">
                    <ul className="social-icons list-unstyled">
                      <li>
                        <a
                          class="fa fa-facebook"
                          target="_blank"
                          href="https://www.facebook.com/aeromallsv"
                        ></a>
                      </li>
                      <li>
                        <a
                          class="fa fa-whatsapp"
                          target="_blank"
                          href="https://api.whatsapp.com/send?phone=50378501743&text=%C2%A1Hola%20%F0%9F%98%8A!%20tengo%20una%20consulta.%20"
                        ></a>
                      </li>
                      <li>
                        <a
                          class="fa fa-instagram"
                          target="_blank"
                          href="https://www.instagram.com/aeromallsv/"
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copyright-bar">
            <div className="container">
              <div className="pull-left flip copyright">
                &copy; <a href="#">Aeromall</a> - Todos Los Derechos Reservados
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="https://www.aeromall.com.sv/termsandconditions">
                  Términos y condiciones
                </a>
              </div>
              <div className="pull-right flip payment">
                <div className="footer-payment-logo">
                  <ul className="cash-card card-inline"></ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </body>
  )
}
